import React from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function CopyPlanTasksToggleWrapper(
  props: {children: React.ReactNode}
) {
  return (
    <ToggleWrapper feature={ToggledFeature.COPY_PLAN_TASKS}>
      {props.children}
    </ToggleWrapper>
  );
}
